import React, { Component } from 'react';
import makeRequest from '../../../../requests/base.request'


class FiltroPeriodoSimulado extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();

        this.onChangeSimulado = this.onChangeSimulado.bind(this);
        this.onChangePeriodo = this.onChangePeriodo.bind(this);
    }

    getInitialState() {
        const initialState = {
            loading: false,
            dados: [],
            periodoSelecionado: undefined,
            simuladoSelecionado: undefined,
        };

        return initialState;
    }

    reset() {
        this.setState(this.getInitialState());
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.idEscola !== prevProps.idEscola) {
            this.getPeriodosSimulados(this.props.idEscola);
        }
    }

    getPeriodosSimulados = async (idEscola) => {
        try {
            if (!idEscola) {
                await this.setState({ dados: [] });
                return;
            }

            this.setState({ loading: true });

            const response = await makeRequest.get('escolas/simulados?school=' + idEscola) || [];
            //console.log(response)
            await this.setState({ dados: response, loading: false, periodoSelecionado: 0, simuladoSelecionado: "00" });

            this.invokeOnChange(0, 0);

        } catch (e) {
            console.error(e)
        }
    }

    onChangeSimulado(indexPeriodo, indexSimulado) {
        this.setState({ periodoSelecionado: indexPeriodo, simuladoSelecionado: `${indexPeriodo}${indexSimulado}` });

        this.invokeOnChange(indexPeriodo, indexSimulado);
    }

    onChangePeriodo(indexPeriodo) {
        var indexSimulado = 0;
        this.setState({ periodoSelecionado: indexPeriodo, simuladoSelecionado: `${indexPeriodo}${indexSimulado}` });

        this.invokeOnChange(indexPeriodo, indexSimulado);
    }

    invokeOnChange(indexPeriodo, indexSimulado) {
        if (this.props.onChange) {
            var periodoAtual = this.state.dados[indexPeriodo] || {};
            var simuladoAtual = (periodoAtual.simulado || [])[indexSimulado] || {};
            //console.log("p",periodoAtual);
            //console.log("s",simuladoAtual);

            var descricao = periodoAtual.nuSchoolPeriod + (simuladoAtual.txPracticeTestType ? (" - " + simuladoAtual.txPracticeTestType) : "");

            this.props.onChange(periodoAtual.nuPeriod, simuladoAtual.idPracticeTestType, descricao)
        }
    }

    render() {
        return (<div className={this.props.className}>
            <strong>Períodos e simulados:</strong>
            <br />
            {this.state.loading && <div><small>Carregando...</small></div>}
            {!this.props.idEscola && <div><small>Selecione uma escola.</small></div>}
            {!this.state.loading && this.state.dados.length === 0 && this.props.idEscola && <div><small>Nenhum item para a escola selecionada.</small></div>}
            {!this.state.loading && this.state.dados.map((item, index) =>
                <div key={`filtro-periodo-${index}`}>
                    <label className="edb-margin-none-bottom">
                        <input type="radio" name="filtro-periodo"
                            value={index}
                            checked={this.state.periodoSelecionado === index}
                            onChange={() => this.onChangePeriodo(index)} />
                        &nbsp;
                    <small>{item.nuSchoolPeriod}</small>
                    </label>

                    {(item.simulado || []).map((itemSimulado, indexSimulado) =>
                        <label key={`filtro-simulado-${index}${indexSimulado}`} className="edb-margin-none-bottom edb-margin-left">
                            <input type="radio" name="filtro-simulado"
                                value={`${index}${indexSimulado}`}
                                checked={this.state.simuladoSelecionado === `${index}${indexSimulado}`}
                                onChange={() => this.onChangeSimulado(index, indexSimulado)} />
                            &nbsp;
                        <small>{itemSimulado.txPracticeTestType}</small>
                        </label>)}
                </div>

            )}

        </div>);
    }

}

export default FiltroPeriodoSimulado;